export const asyncActionTypes = (type) => ({
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`
})

export const STATUS = {
  IDLE: 'IDLE',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  UPLOADING: 'UPLOADING',
  SYNCING: 'SYNCING'
}

const SOCKET_STATUS = {
  CONNECTING: 'CONNECTING',
  OPEN: 'OPEN',
  REGISTERED: 'REGISTERED',
  CLOSING: 'CLOSING',
  CLOSED: 'CLOSED'
}

const NO_ACTION = 'NO_ACTION'

const API = 'API'
const CHAIN = 'CHAIN'
const SOCKET = 'SOCKET'

const CONNECT_SOCKET = 'CONNECT_SOCKET'
const DISCONNECT_SOCKET = 'DISCONNECT_SOCKET'
const REGISTER_SOCKET = 'REGISTER_SOCKET'

const LOAD_CLASSROOM = asyncActionTypes('LOAD_CLASSROOM')
const RESET_CLASSROOM = 'RESET_CLASSROOM'

const LOAD_COLLEGES = asyncActionTypes('LOAD_COLLEGES')
const RESET_COLLEGES = 'RESET_COLLEGES'

const CREATE_CONTACT = asyncActionTypes('CREATE_CONTACT')
const LOAD_CONTACT = asyncActionTypes('LOAD_CONTACT')
const UPDATE_CONTACT = 'UPDATE_CONTACT'

const LOAD_CONTACTS = asyncActionTypes('LOAD_CONTACTS')
const UPDATE_CONTACTS = 'UPDATE_CONTACTS'
const RESET_CONTACTS = 'RESET_CONTACTS'

const LOAD_CONVERSATION = asyncActionTypes('LOAD_CONVERSATION')
const UPDATE_CONVERSATION = asyncActionTypes('UPDATE_CONVERSATION')
const ACTIVATE_CONVERSATION = 'ACTIVATE_CONVERSATION'
const UPDATE_CONVERSATION_PRIVATE_MODE = 'UPDATE_CONVERSATION_PRIVATE_MODE'
const UPDATE_CONVERSATION_STATE = 'UPDATE_CONVERSATION_STATE'
const RESET_CONVERSATION = 'RESET_CONVERSATION'
const RESET_CONVERSATIONS = 'RESET_CONVERSATIONS'

const LOAD_MESSAGES = asyncActionTypes('LOAD_MESSAGES')

const CREATE_MESSAGE = asyncActionTypes('CREATE_MESSAGE')
const LOAD_MESSAGE = 'LOAD_MESSAGE'
const UPDATE_MESSAGE = 'UPDATE_MESSAGE'

const LOAD_FILES = asyncActionTypes('LOAD_FILES')
const RESET_FILES = 'RESET_FILES'

const CREATE_FILE_BOOKMARK = asyncActionTypes('CREATE_FILE_BOOKMARK')
const DELETE_FILE_BOOKMARK = asyncActionTypes('DELETE_FILE_BOOKMARK')

const CREATE_FILE = asyncActionTypes('CREATE_FILE')
const UPLOAD_FILE = asyncActionTypes('UPLOAD_FILE')
const UPLOAD_PROFILE_FILE = asyncActionTypes('UPLOAD_PROFILE_FILE')
const LOAD_FILE = asyncActionTypes('LOAD_FILE')
const UPDATE_FILE = asyncActionTypes('UPDATE_FILE')
const DELETE_FILE = asyncActionTypes('DELETE_FILE')

const CREATE_SESSION = asyncActionTypes('CREATE_SESSION')
const LOAD_SESSIONS = asyncActionTypes('LOAD_SESSIONS')
const LOAD_SESSION = asyncActionTypes('LOAD_SESSION')
const UPDATE_SESSION = asyncActionTypes('UPDATE_SESSION')
const ACT_ON_SESSION = asyncActionTypes('ACT_ON_SESSION')
const UPDATE_SESSION_LOCALLY = 'UPDATE_SESSION_LOCALLY'
const RESET_SESSIONS = 'RESET_SESSIONS'

const LOAD_SKILLS = asyncActionTypes('LOAD_SKILLS')
const RESET_SKILLS = 'RESET_SKILLS'

const AUTHENTICATE_USER = asyncActionTypes('AUTHENTICATE_USER')
const CREATE_USER = asyncActionTypes('CREATE_USER')
const UPDATE_USER = asyncActionTypes('UPDATE_USER')
const UPLOAD_BACKGROUND_FILE = asyncActionTypes('UPLOAD_BACKGROUND_FILE')
const RESET_USER = 'RESET_USER'
const COOKIE_LOGOUT = asyncActionTypes('COOKIE_LOGOUT')

export default {
  SOCKET_STATUS,
  STATUS,

  API,
  CHAIN,
  SOCKET,

  CONNECT_SOCKET,
  DISCONNECT_SOCKET,
  REGISTER_SOCKET,

  NO_ACTION,

  LOAD_CLASSROOM,
  RESET_CLASSROOM,

  LOAD_COLLEGES,
  RESET_COLLEGES,

  CREATE_CONTACT,
  LOAD_CONTACT,
  UPDATE_CONTACT,

  LOAD_CONTACTS,
  UPDATE_CONTACTS,
  RESET_CONTACTS,

  LOAD_CONVERSATION,
  UPDATE_CONVERSATION,
  UPDATE_CONVERSATION_STATE,
  UPDATE_CONVERSATION_PRIVATE_MODE,
  ACTIVATE_CONVERSATION,
  RESET_CONVERSATION,
  RESET_CONVERSATIONS,

  LOAD_MESSAGES,

  CREATE_MESSAGE,
  LOAD_MESSAGE,
  UPDATE_MESSAGE,

  LOAD_FILES,
  RESET_FILES,

  CREATE_FILE_BOOKMARK,
  DELETE_FILE_BOOKMARK,

  CREATE_FILE,
  UPLOAD_FILE,
  UPLOAD_PROFILE_FILE,
  LOAD_FILE,
  UPDATE_FILE,
  DELETE_FILE,

  CREATE_SESSION,
  LOAD_SESSIONS,
  LOAD_SESSION,
  UPDATE_SESSION,
  ACT_ON_SESSION,
  UPDATE_SESSION_LOCALLY,
  RESET_SESSIONS,

  LOAD_SKILLS,
  RESET_SKILLS,

  AUTHENTICATE_USER,
  CREATE_USER,
  UPDATE_USER,
  UPLOAD_BACKGROUND_FILE,
  RESET_USER,
  COOKIE_LOGOUT
}
